import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import {
  DEFAULT_LOCALE,
  getLocaleFromPathname,
  normalizeLocale,
  withLocalePath,
} from "../utils/localeRouting";

export const LocaleRouterSync = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { language, setLanguage } = useAuth();

  useEffect(() => {
    const routeLocale = getLocaleFromPathname(location.pathname);
    const preferredLocale = normalizeLocale(language || DEFAULT_LOCALE);
    const fullPath = `${location.pathname}${location.search}${location.hash}`;

    if (!routeLocale) {
      navigate(withLocalePath(fullPath, preferredLocale), { replace: true });
      return;
    }

    if (routeLocale !== preferredLocale) {
      setLanguage(routeLocale);
    }
  }, [
    language,
    location.hash,
    location.pathname,
    location.search,
    navigate,
    setLanguage,
  ]);

  return null;
};
